"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var searchBoxBaseTheme = function (_a) {
    var _b;
    var MAX_M = _a.MAX_M;
    return ({
        searchBox: (_b = {
                display: "flex",
                width: "100%",
                height: "3rem",
                padding: "0.5rem",
                borderRadius: "0.25rem"
            },
            _b[MAX_M] = {
                alignSelf: "flex-end"
            },
            _b),
        searchBoxIcon: {
            name: "search",
            cursor: "pointer"
        },
        searchBoxAdornment: {
            marginRight: "1rem"
        },
        searchBoxInput: {
            paddingLeft: "1rem"
        }
    });
};
exports.default = searchBoxBaseTheme;
//# sourceMappingURL=searchBox.js.map